module.exports = __webpack_public_path__ + "static/event-placeholder-803039a50df11a20bb19e43bac6eac66.jpg";